import CircleContainer from './circle-container';
import Container from '@/components/Container';
import PageHeader from '@/components/PageHeader';

import CharacterCompassSkeleton from './loading/CharacterCompass.skeleton';
import { MessageContainer } from './message-container';
import { useCharacterCompassStore } from './store/useCharacterCompassStore';
import { useAuthentication } from '@/hooks/useAuthentication';
import GenericOnboarding from '@/components/generic-onboarding';
import { onChangeOnboardStatus } from '@/services/daily/character-compass.service';
import { ResetCharacterCompassButton } from './reset-character-compass-button';
import { parseTextWithLinks } from '@/utils/navigation';
import { useState } from 'react';
import { CharacterCompassFinished } from './character-compass-finished';
import { Calendar } from '../calendar/components/calendar';
import { useCharacterCompass } from './hooks/useCharacterCompass';

export default function EmotionalWheelPage() {
  const [showCalendarAndRelatedContent, setShowCalendarAndRelatedContent] = useState(false);
  const { characterCompassPage, loading, SubTrait, Trait, traits } = useCharacterCompassStore();

  // init data
  // eslint-disable-next-line no-empty-pattern
  const {} = useCharacterCompass();
  const { authentication, toggleOnboardingStatus } = useAuthentication();

  const renderContent = () => {
    if (!authentication?.user?.onboardCharacterCompassCompleted) {
      return (
        <GenericOnboarding
          onboarding={characterCompassPage?.onboarding}
          onFinish={async () => {
            await onChangeOnboardStatus();
            toggleOnboardingStatus('onboardCharacterCompassCompleted');
          }}
        />
      );
    }

    return (
      <div className="col-span-12 gap-4 lg:col-start-3 lg:col-end-11">
        <div>
          {!loading && !SubTrait && (
            <div className="mt-sh-30 flex flex-col items-center justify-center md:mb-8 xl:min-h-[400px]">
              <>
                <div className="mr-sh-30 flex items-center justify-center  ">
                  <MessageContainer />
                </div>
                <div className="flex items-center justify-center md:mt-0 xl:justify-start">
                  <CircleContainer />
                </div>
                <ResetCharacterCompassButton show={!!Trait! && !SubTrait} onlyMobile />
              </>
            </div>
          )}
          {!SubTrait && (
            <div className="mt-sh-30 flex flex-col items-center  md:mt-0">
              <p className="text-center font-cadiz text-sh-14-18">{characterCompassPage?.messages?.privacyStatement}</p>
              <p
                key="firstText"
                className="mt-sh-20 text-center text-sh-xxs"
                dangerouslySetInnerHTML={{
                  __html: parseTextWithLinks(
                    characterCompassPage?.TraitNotFound?.text || '',
                    characterCompassPage?.TraitNotFound?.finalState,
                  ),
                }}
              />
            </div>
          )}

          {SubTrait && (
            <CharacterCompassFinished
              onClickShowCompassTrackerButton={() => {
                setShowCalendarAndRelatedContent(true);
              }}
              showCalendarAndRelatedContent={showCalendarAndRelatedContent}
            />
          )}

          {showCalendarAndRelatedContent && (
            <>
              <Calendar isCharacterCompassPage />
              <ResetCharacterCompassButton show={!!SubTrait} forceShow />
            </>
          )}
        </div>
      </div>
    );
  };

  return (
    <div className="min-h-[46rem]">
      <Container className="mt-sh-60">
        <div className="col-span-12 gap-4 lg:col-start-3 lg:col-end-11">
          <PageHeader title="Character Compass" url="/" type="none" />
        </div>

        {renderContent()}

        <div className="col-span-12 gap-4 lg:col-start-3 lg:col-end-11">
          <div>{loading && <CharacterCompassSkeleton />}</div>
        </div>

        {!loading && (
          <div className="col-span-12 gap-4 lg:col-start-3 lg:col-end-11">
            <div className="rounded-sh-16 border border-primary-500 p-10">
              <h2 className="mb-sh-30 text-center font-cadiz text-sh-28-32 font-bold">
                {characterCompassPage?.traitDetailsTitle || 'The RESPECT Framework'}
              </h2>
              {traits?.map((trait) => (
                <article
                  className="mb-sh-30 grid grid-cols-1 items-center gap-4 last:mb-0 md:grid-cols-[95px_1fr]"
                  aria-labelledby={trait?.attributes?.trait}
                  key={trait?.id}>
                  <div>
                    <img
                      src={trait?.attributes?.overallMoodIcon?.data?.attributes?.url}
                      alt=""
                      className="h-[95px] w-[95px]"
                    />
                  </div>
                  <div className="flex flex-col">
                    <h2 className="mb-1 font-cadiz text-sh-28-32 font-bold">{trait?.attributes?.trait}</h2>
                    <p className="font-cadiz text-sh-16-24">{trait?.attributes?.description}</p>
                  </div>
                </article>
              ))}
            </div>
          </div>
        )}
      </Container>
    </div>
  );
}
